module.exports = __webpack_public_path__ + "static/media/photo4.4e5bdb3b.jpg";